import { Tooltip } from "@material-ui/core";
import { memo } from "react";

import MarkerDeactivated from "@/assets/img/map/MarkerDeactivated.svg";
import { useStyles } from "@/common/components/MapLandingPage/Map/DeactivatedUnitMarker/DeactivatedUnitMarkerStyles";

import { MarkerProps } from "../types";


const DeactivatedUnitMarker: React.FC<MarkerProps> = ({ lat, lng, text, unitId, onClick }) => {
    const classes = useStyles();

    return (
        <Tooltip title={text} classes={{ popper: classes.tooltip }}>
            <div className={classes.marker} onClick={() => onClick({ unitId, lat, lng, text, isDeactivated: true })}>
                <img src={MarkerDeactivated} alt="Deactivated Live Unit" />
            </div>
        </Tooltip>
    );
};

export default memo(DeactivatedUnitMarker);
